// AUTO GENERATED FILE

import { Accordion } from './components/Accordion'
import { AnchorScrollNavbar } from './components/AnchorScrollNavbar'
import { AnimateIntoView } from './components/AnimateIntoView'
import { AnimatedBurger } from './components/AnimatedBurger'
import { Apps } from './components/Apps'
import { AppsList } from './components/AppsList'
import { ArrayCTA } from './components/ArrayCTA'
import { BasicHedgehogImage } from './components/BasicHedgehogImage'
import { BlockQuote } from './components/BlockQuote'
import { Blog } from './components/Blog'
import { BlogFooter } from './components/BlogFooter'
import { BorderWrapper } from './components/BorderWrapper'
import { Breadcrumbs } from './components/Breadcrumbs'
import { CallToAction } from './components/CallToAction'
import { Card } from './components/Card'
import { Benefits } from './components/Careers/Benefits'
import { CareersHero } from './components/Careers/CareersHero'
import { InterviewProcess } from './components/Careers/InterviewProcess'
import { OpenRoles } from './components/Careers/OpenRoles'
import { Transparency } from './components/Careers/Transparency'
import { WhyWereHere } from './components/Careers/WhyWereHere'
import { WorkingAtPostHog } from './components/Careers/WorkingAtPostHog'
import { Checkbox } from './components/Checkbox'
import { Chip } from './components/Chip'
import { CodeBlock } from './components/CodeBlock'
import { CommunityQuestions } from './components/CommunityQuestions'
import { CompensationCalculator } from './components/CompensationCalculator'
import { Contact } from './components/Contact'
import { ContactForm } from './components/ContactForm'
import { Container } from './components/Container'
import { ContributorCard } from './components/ContributorCard'
import { ContributorSearch } from './components/ContributorSearch'
import { ContributorsChart } from './components/ContributorsChart'
import { Customers } from './components/Customers'
import { DarkModeToggle } from './components/DarkModeToggle'
import { DemoScheduler } from './components/DemoScheduler'
import { DeployOption } from './components/DeployOption'
import { DocsPageSurvey } from './components/DocsPageSurvey'
import { FeatureAvailability } from './components/FeatureAvailability'
import { FeaturesSelfHost } from './components/FeaturesSelfHost'
import { FloatedImage } from './components/FloatedImage'
import { Footer } from './components/Footer'
import { FooterCTA } from './components/FooterCTA'
import { FullWidthBorderSlider } from './components/FullWidthBorderSlider'
import { GDPRForm } from './components/GDPRForm'
import { GithubIcon } from './components/GithubIcon'
import { Heading } from './components/Heading'
import { HiddenSection } from './components/HiddenSection'
import { Home } from './components/Home'
import { HostingOption } from './components/HostingOption'
import { ImageBlock } from './components/ImageBlock'
import { IngestionAppsList } from './components/IngestionAppsList'
import { InlineCode } from './components/InlineCode'
import { LandingPageCallToAction } from './components/LandingPage/LandingPageCallToAction'
import { LibraryFeatures } from './components/LibraryFeatures'
import { Link } from './components/Link'
import { Logo } from './components/Logo'
import { MainNav } from './components/MainNav'
import { MdxAnchorHeaders } from './components/MdxAnchorHeaders'
import { Modal } from './components/Modal'
import { NewsletterForm } from './components/NewsletterForm'
import { NewsletterTutorial } from './components/NewsletterTutorial'
import { NextSteps } from './components/NextSteps'
import { NotFoundPage } from './components/NotFoundPage'
import { OverflowXSection } from './components/OverflowXSection'
import { Popover } from './components/Popover'
import { PostCard } from './components/PostCard'
import { PostLayout } from './components/PostLayout'
import { AllPlans } from './components/Pricing/AllPlans'
import { AllPlansTest } from './components/Pricing/AllPlansTest'
import { Calculator } from './components/Pricing/Calculator'
import { CloudVsSelfHost } from './components/Pricing/CloudVsSelfHost'
import { FAQs } from './components/Pricing/FAQs'
import { Features } from './components/Pricing/Features'
import { PlanComparison } from './components/Pricing/PlanComparison'
import { PlanComparisonTest } from './components/Pricing/PlanComparisonTest'
import { PricingHero } from './components/Pricing/PricingHero'
import { PricingSlider } from './components/Pricing/PricingSlider'
import { PricingTable } from './components/Pricing/PricingTable'
import { ProductPillars } from './components/Pricing/ProductPillars'
import { Quote } from './components/Pricing/Quote'
import { Savings } from './components/Pricing/Savings'
import { ProductAnchorNavbar } from './components/ProductAnchorNavbar'
import { ProductFeature } from './components/ProductFeature'
import { ProductFeaturePlugin } from './components/ProductFeaturePlugin'
import { ProductFooter } from './components/ProductFooter'
import { ProductIcons } from './components/ProductIcons'
import { ProductPage } from './components/ProductPage'
import { ProductSectionHeader } from './components/ProductSectionHeader'
import { Question } from './components/Question'
import { Quote2 } from './components/Quote2'
import { RocketHorizontalRule } from './components/RocketHorizontalRule'
import { SearchBox } from './components/SearchBox'
import { SectionLinks } from './components/SectionLinks'
import { DesignedForYourStackBlock } from './components/Sections/DesignedForYourStackBlock'
import { FeaturedSectionTextLeft } from './components/Sections/FeaturedSectionTextLeft'
import { FeaturedSectionTextRight } from './components/Sections/FeaturedSectionTextRight'
import { FeaturedSectionTripleImage } from './components/Sections/FeaturedSectionTripleImage'
import { SliderNav } from './components/SliderNav'
import { Spacer } from './components/Spacer'
import { Spinner } from './components/Spinner'
import { StarRepoButton } from './components/StarRepoButton'
import { StarUsBanner } from './components/StarUsBanner'
import { Structure } from './components/Structure'
import { Subscribe } from './components/Subscribe'
import { Tab } from './components/Tab'
import { TeamQuote } from './components/TeamQuote'
import { Toggle } from './components/Toggle'
import { Tooltip } from './components/Tooltip'
import { TotalCountries } from './components/TotalCountries'
import { TotalTeam } from './components/TotalTeam'
import { Tutorials } from './components/Tutorials'
import { TutorialsSlider } from './components/TutorialsSlider'
import { VisitLibrary } from './components/VisitLibrary'
import { WorkableOpenRoles } from './components/WorkableOpenRoles'
import { WorkableSnippet } from './components/WorkableSnippet'
import { ZoomImage } from './components/ZoomImage'

export const shortcodes = {
    Accordion,
    AnchorScrollNavbar,
    AnimateIntoView,
    AnimatedBurger,
    Apps,
    AppsList,
    ArrayCTA,
    BasicHedgehogImage,
    BlockQuote,
    Blog,
    BlogFooter,
    BorderWrapper,
    Breadcrumbs,
    CallToAction,
    Card,
    Benefits,
    CareersHero,
    InterviewProcess,
    OpenRoles,
    Transparency,
    WhyWereHere,
    WorkingAtPostHog,
    Checkbox,
    Chip,
    CodeBlock,
    CommunityQuestions,
    CompensationCalculator,
    Contact,
    ContactForm,
    Container,
    ContributorCard,
    ContributorSearch,
    ContributorsChart,
    Customers,
    DarkModeToggle,
    DemoScheduler,
    DeployOption,
    DocsPageSurvey,
    FeatureAvailability,
    FeaturesSelfHost,
    FloatedImage,
    Footer,
    FooterCTA,
    FullWidthBorderSlider,
    GDPRForm,
    GithubIcon,
    Heading,
    HiddenSection,
    Home,
    HostingOption,
    ImageBlock,
    IngestionAppsList,
    InlineCode,
    LandingPageCallToAction,
    LibraryFeatures,
    Link,
    Logo,
    MainNav,
    MdxAnchorHeaders,
    Modal,
    NewsletterForm,
    NewsletterTutorial,
    NextSteps,
    NotFoundPage,
    OverflowXSection,
    Popover,
    PostCard,
    PostLayout,
    AllPlans,
    AllPlansTest,
    Calculator,
    CloudVsSelfHost,
    FAQs,
    Features,
    PlanComparison,
    PlanComparisonTest,
    PricingHero,
    PricingSlider,
    PricingTable,
    ProductPillars,
    Quote,
    Savings,
    ProductAnchorNavbar,
    ProductFeature,
    ProductFeaturePlugin,
    ProductFooter,
    ProductIcons,
    ProductPage,
    ProductSectionHeader,
    Question,
    Quote2,
    RocketHorizontalRule,
    SearchBox,
    SectionLinks,
    DesignedForYourStackBlock,
    FeaturedSectionTextLeft,
    FeaturedSectionTextRight,
    FeaturedSectionTripleImage,
    SliderNav,
    Spacer,
    Spinner,
    StarRepoButton,
    StarUsBanner,
    Structure,
    Subscribe,
    Tab,
    TeamQuote,
    Toggle,
    Tooltip,
    TotalCountries,
    TotalTeam,
    Tutorials,
    TutorialsSlider,
    VisitLibrary,
    WorkableOpenRoles,
    WorkableSnippet,
    ZoomImage,
}
